// extracted by mini-css-extract-plugin
module.exports = {"sun":"styles_sun__Mep_m","loading-wheel":"styles_loading-wheel__cQMP6"};